import Swiper, {Navigation} from 'swiper'

const MoreNews = () => {

  const swiper = new Swiper('.more-news-slider', {
    modules: [Navigation],
    
    slidesPerView: 1,
    spaceBetween: 30,
    loop: true,

    navigation: {
      nextEl: '.more-news-navigation .slider-button-next',
      prevEl: '.more-news-navigation .slider-button-prev',
    },
    
    breakpoints: {
      0: {
        slidesPerView: 1,
      },
      580: {
        slidesPerView: 2,
      },
      768: {
        slidesPerView: 3,
      },
      1024: {
        slidesPerView: 2,
      },
    },
    
  })
}

export default MoreNews
